import http from "./http";

// Logout helper
function logout() {
  http.post("/logout")
    .then(() => {
      refresh();
    })
    .catch(() => {
      window.location.href = "/";
    });
}

// Uuid helper
function uuid(n = 12) {
  let text = "";
  let possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

  for (let i = 0; i < n; i++)
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  return text;
}

// Refresh helper
function refresh() {
  location.reload();
}

window.refresh = refresh;
window.logout = logout;
window.uuid = uuid;

export { refresh, uuid, logout };

/*
|--------------------------------------------------------------------------
| String Helpers
|--------------------------------------------------------------------------
*/

/** Capitalize */
String.prototype.capitalize = function () {
  return this.charAt(0).toUpperCase() + this.slice(1);
};

/** Truncate string */
String.prototype.limit = function (count) {
  return this.slice(0, count) + (this.length > count ? "..." : "");
};

/*
|--------------------------------------------------------------------------
| Number Helpers
|--------------------------------------------------------------------------
*/

/** Number Format */
Number.prototype.format = function (n = undefined) {
  new Intl.NumberFormat(window.Laravel.app.locale, { minimumFractionDigits: n, maximumFractionDigits: n }).format(this);
};

/** Price Format */
Number.prototype.priceFormat = function (n = 2) {
  return new Intl.NumberFormat(window.Laravel.app.locale, { style: "currency", currency: "USD", minimumFractionDigits: n, maximumFractionDigits: n }).format(this) + " USD";
};

/** Percentage Format */
Number.prototype.percentageFormat = function (n = undefined) {
  return new Intl.NumberFormat(window.Laravel.app.locale, { style: "percent", minimumFractionDigits: n, maximumFractionDigits: n }).format(this);
};
